module.exports = __webpack_public_path__ + "school/img/zhujian.a751feea.jpg";